import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { createEntityFormAdapter } from '@tdp/common/form';

import { BotEventSubscription, EmptyBotEventSubscription, BotEventSubscriptionSchema } from './models.eventSubscription';

const eventSubscriptionEntityAdapter = createEntityAdapter<BotEventSubscription, string>({
  selectId: (sub) => sub.id,
});
const eventSubscriptionFormAdapter = createEntityFormAdapter(eventSubscriptionEntityAdapter);

export const botEventSubscriptionSlice = createSlice({
  name: 'botEventSubscription',
  initialState: eventSubscriptionFormAdapter.getInitialState({ loading: false }),
  reducers: {
    subscriptionLoading: (state) => {
      state.loading = true;
    },
    subscriptionLoaded: (state, action: PayloadAction<BotEventSubscription>) => {
      state.loading = false;
      eventSubscriptionEntityAdapter.upsertOne(state, action.payload);
    },
    clearSubscription: (state) => {
      eventSubscriptionEntityAdapter.removeAll(state);
      state.loading = false;
    },
    ...eventSubscriptionFormAdapter.getReducers(),
  },
  selectors: {
    isLoading: (s) => s.loading,
    ...eventSubscriptionEntityAdapter.getSelectors(),
    ...eventSubscriptionFormAdapter.getSelectors(EmptyBotEventSubscription, BotEventSubscriptionSchema),
  },
});
